import axios from "axios";
import get from "lodash/get";
import * as Sentry from "@sentry/react";
import config from "config";
import storage from "../storage";
import authActions from "store/actions/auth";

const request = axios.create({
	baseURL: config.API_ROOT
});

let storeRef = null;

request.defaults.params = {};
request.defaults.params['_f'] = 'json';
request.defaults.headers.common['Accept'] = 'application/json';
request.defaults.headers.common['Cache-Control'] = 'no-cache';
request.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';

// FormData must not use the default JSON Content-Type — otherwise the body is
// serialized as JSON and binary uploads break (UploadS2, excel import, etc.).
request.interceptors.request.use(cfg => {
	if (typeof FormData !== "undefined" && cfg.data instanceof FormData) {
		if (cfg.headers && typeof cfg.headers.delete === "function") {
			cfg.headers.delete("Content-Type");
		} else {
			delete cfg.headers["Content-Type"];
		}
	}
	return cfg;
});

let token = storage.get("token");

const subscribe = store => {
	storeRef = store;
	let state = store.getState();
	request.defaults.params['_l'] = state.system.currentLangCode;
	request.defaults.params['_c'] = state.system.currentCountryCode;
	if (get(state, "auth.token")) token = get(state, "auth.token");
	if (token) {
		request.defaults.headers.common["Authorization"] = `Bearer ${token}`;
	}
};


/**
 * API Sentry Error Tracker
 */
request.interceptors.response.use(
	(response) => response,
	(error) => {
		if (get(error, "response.status") === 404 && storeRef) {
			storeRef.dispatch(authActions.SetMaintenanceMode.request(true));
		}

		const expectedError =
			error.response &&
			error.response.status >= 400 &&
			error.response.status < 500;

		if(!expectedError){
			Sentry.withScope((scope) => {
				scope.setExtra("Error URL", get(error, "config.url"));
				scope.setExtra("Error Message", get(error, "response.data.message"));
				scope.setExtra("Error Status", `${get(error, "response.status")} - ${get(error, "response.statusText")}`);
				scope.setExtra("Error Full", error);
				Sentry.captureException(error);
			});
		}

		return Promise.reject(error);
	}
);

export default {
	request,
	subscribe
};
